import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, BoltIcon } from '@heroicons/react/24/outline';
import { utilities } from '../../content/utilities';
import SunRaysHero from '../Services/SunRaysHero';

function Eyebrow({ children, dark = false }) {
	return (
		<p
			className={`text-xs font-semibold uppercase tracking-[0.18em] ${
				dark ? 'text-primary-400' : 'text-primary-600'
			}`}
		>
			<span className='inline-block w-8 h-px align-middle mr-3 bg-current opacity-60' />
			{children}
		</p>
	);
}

// Index for the utility-specific pages. These exist because homeowners literally
// search "Solar BGE Maryland" / "Pepco net metering" — questions Gabe answers
// every day (idea #4).
export default function Utilities() {
	return (
		<div className='bg-surface text-ink-900 antialiased'>
			<section className='relative isolate overflow-hidden border-b border-ink-100'>
				<SunRaysHero seed={5} />
				<div className='mx-auto max-w-7xl px-6 py-20 sm:py-28 lg:px-8'>
					<Eyebrow>By utility</Eyebrow>
					<h1 className='font-display mt-5 text-5xl font-medium tracking-tight text-ink-900 sm:text-6xl leading-[1.05]'>
						Solar with your utility.
					</h1>
					<p className='mt-6 max-w-2xl text-lg leading-8 text-ink-600'>
						Net metering, paperwork, meter swaps, and Permission to Operate all
						run through your utility. Start with the page for yours.
					</p>
				</div>
			</section>

			<section className='bg-white py-20 sm:py-28'>
				<div className='mx-auto max-w-7xl px-6 lg:px-8'>
					<div className='grid grid-cols-1 gap-6 md:grid-cols-2'>
						{utilities.map((u) => (
							<Link
								key={u.id}
								to={`/solar-with/${u.id}`}
								className='group sg-card sg-card-interactive p-8'
							>
								<div className='sg-badge'>
									<BoltIcon
										className='h-5 w-5'
										aria-hidden='true'
									/>
								</div>
								<h2 className='font-display mt-6 text-2xl font-medium text-ink-900'>
									{u.label}
								</h2>
								<p className='mt-1 text-xs font-semibold uppercase tracking-[0.14em] text-ink-400'>
									{u.region}
								</p>
								<p className='mt-3 text-sm leading-6 text-ink-500'>
									{u.summary}
								</p>
								<span className='mt-6 inline-flex items-center gap-1 text-sm font-semibold text-primary-600 group-hover:gap-2 transition-all'>
									Learn more <ArrowRightIcon className='h-4 w-4' />
								</span>
							</Link>
						))}
					</div>
				</div>
			</section>
		</div>
	);
}
